import { useFormContext } from "react-hook-form";
import InputText from "../../components/InputText";
import AddressInput from "../../components/AddressInput";

function StoreInformation() {
  const { control, setValue } = useFormContext();
  return (
    <div className="max-w-[700px] w-full mx-auto grid gap-y-10">
      <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-x-4 gap-y-3">
        <InputText
          control={control}
          name="selling_store_location"
          type="text"
          label="Selling Store Location"
          required
        />

        <InputText
          control={control}
          name="sales_person_id"
          type="text"
          label="Salesperson ID"
        />
      </div>
      <div className="grid gap-y-3">
        <h3 className="text-gray-900 font-semibold">Store Address</h3>
        <div className="grid min-[600px]:grid-cols-2 grid-cols-1 gap-x-4 gap-y-3">
          <AddressInput
            control={control}
            name="sellingStoreAddress.address"
            onAddressSelect={(address) => {
              setValue("sellingStoreAddress.city", address.city);
              setValue("sellingStoreAddress.state", address.state);
              setValue("sellingStoreAddress.zip_code", address.zipCode);
            }}
            label="Street Address"
          />
          {/* <InputText
            control={control}
            name="sellingStoreAddress.address_2"
            type="text"
            label="Address Line 2"
          /> */}
          <InputText
            control={control}
            name="sellingStoreAddress.city"
            label="City"
          />
          <div className="min-[600px]:col-span-2 max-[600px]:grid-cols-2 grid-cols-3  grid gap-x-4 gap-y-3">
            <InputText
              control={control}
              name="sellingStoreAddress.state"
              label="State/Province"
            />
            <InputText
              control={control}
              name="sellingStoreAddress.zip_code"
              label="Postal Code"
            />
            <InputText
              control={control}
              name="sellingStoreAddress.country_code"
              label="Country Code"
              defaultValue="USA"
              inputProps={{
                maxLength: 3,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreInformation;
